import { forwardRef, useState } from 'react';
import { LayoutRow, LayoutCol } from '@/components/Elements/Layout';
import { Sidebar, NEW_LAYOUT_UI } from './Sidebar';
import useIframe from '@/hooks/useIframe';
import { twMerge } from 'tailwind-merge';
import isRouteActive from '@/utils/isRouteActive';

export const MainLayout = forwardRef((props, ref) => {
  const { children } = props;
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const { isAppInIframe } = useIframe();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <>
      <div className="flex">
        {!isAppInIframe && (
          <div className="h-screen transition-all duration-300">
            <Sidebar
              isCollapsed={isSidebarCollapsed}
              toggleSidebar={toggleSidebar}
            />
          </div>
        )}
        <LayoutRow
          cols={10}
          className={twMerge(
            'h-full w-full',
            NEW_LAYOUT_UI.some((ui) => isRouteActive(ui)) && 'h-screen'
          )}
        >
          <LayoutCol
            span={10}
            className={twMerge(
              'overflow-y-auto bg-brand-layout-light transition-all duration-300',
              NEW_LAYOUT_UI.some((ui) => isRouteActive(ui)) &&
                'm-2 ml-0 rounded-xl bg-[linear-gradient(236deg,_#FFF_-46.52%,_#F5F8FF_132.76%)]'
            )}
          >
            {children}
          </LayoutCol>
        </LayoutRow>
      </div>
    </>
  );
});
